import { BrandColorMapType } from 'common/types/common';
import { atom } from 'recoil';

export const brandsColorMapAtom = atom<BrandColorMapType | null>({
  key: 'brandsColorMap',
  default: null,
});
